//
// BaseVoucher.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseModel";
import "../models/warnings/Warning";

var BaseVoucher = createModule("commons::BaseVoucher", [], EventDispatcher, [
    {
        FULFILLED: 10006,
        ISSUED: 10004,
        CANCELLED: 10005,
        WARNING: 10007,
    },
    ,
    ,
    ,
    {
        cancel: [0],
        getType: [4],
        getAssociatedModel: [1],
        getBaseWarning: [1],
        isCompleted: [2],
    },
    {
        _create: [4],
    },
    ,
]);
export default BaseVoucher;
